export default __webpack_public_path__ + "static/media/bluehouse.13b60f8b.svg";